import { ARIAS } from '../utils/constants';

const initCustomDropdowns = () => {
  const dropdowns = document.querySelectorAll('[data-dropdown]');
  if (!dropdowns.length) return;

  dropdowns.forEach(dropdown => {
    const toggleBtn = dropdown.querySelector('[data-dropdown-toggle]');
    const dropdownList = dropdown.querySelector('[data-dropdown-list]');
    const form = dropdown.querySelector('form');
    const languageInput = dropdown.querySelector('[data-dropdown-lang-input]');
    const items = dropdown.querySelectorAll('[data-dropdown-item]');

    const hideDropdown = () => {
      toggleBtn?.setAttribute(ARIAS.EXPANDED, 'false');
      dropdownList?.classList.add('hidden');
    };

    const toggleDropdown = () => {
      const isExpanded = toggleBtn?.getAttribute(ARIAS.EXPANDED) === 'true';
      toggleBtn?.setAttribute(ARIAS.EXPANDED, (!isExpanded).toString());
      dropdownList?.classList.toggle('hidden');
    };

    const onFocusOut = (event) => {
      const shouldClose = event.relatedTarget?.hasAttribute('data-dropdown-toggle');
      if (!event.relatedTarget || shouldClose) {
        hideDropdown();
      }
    };

    const onKeyUp = (event) => {
      if (event.code?.toUpperCase() === 'ESCAPE') {
        hideDropdown();
        toggleBtn?.focus();
      }
    };

    const onItemClick = (event) => {
      event.preventDefault();
      const value = event.currentTarget?.dataset?.value;
      if (value && languageInput) {
        languageInput.value = value;
      }
      form?.submit();
    };

    toggleBtn?.addEventListener('click', toggleDropdown);
    toggleBtn?.addEventListener('focusout', onFocusOut);
    dropdown.addEventListener('keyup', onKeyUp);
    if (items.length) items.forEach(item => item.addEventListener('click', onItemClick));
  });
};

export default initCustomDropdowns;
